import { BsAjax, BsGetcapis, BsGetCid, BsUtil, BsGetXcx } from 'dida-web-common'
import DATA from './../pageConf.js'

export default async function getActiveData(_v, acCode, acType, condition, paramsList, fn) {
  try {
    // 1. 准备基础数据
    const baseData = await prepareBaseData()
    if (!baseData.cmspromotionCode) return

    // 2. 解析请求配置
    const { requestUrl, isFormData, activityTypeNew } = resolveRequestConfig(_v, baseData)

    // 3. 构建请求参数
    const rqData = buildRequestData({
      baseData,
      cid: baseData.cid,
      isFormData,
      isWx: baseData.isWx,
      acCode,
      acType,
      condition,
      paramsList
    })
    Promise.all(rqData.map((requestData) => {
        return fetchActivityData({ requestUrl, requestData, isFormData, fn, _v })
    })).then((response) => {
        const deep = deepMerge(response)
        if (response.length > 1) {
            deep.map.code = response[0].map.code
            deep.map.message = response[0].map.message
        }
        const activityList = processResponseData(deep, activityTypeNew, baseData.activityCode)
        updateVueState(_v, activityList)
        _v.$bus.$emit('updateActiveDate')
    })
  } catch (error) {
    handleError(error, _v)
  }
}

/** ========== 工具函数区域 ========== */

/**
 * 准备基础数据
 */
async function prepareBaseData() {
  const { cid } = await BsGetCid()
  const { isWx } = await BsGetXcx()
  const basic = DATA.options.basic?.getDataMes || DATA.options.basic
  const {
    url,
    activityType,
    params,
    activityCode,
    guestUrl,
    promotionCode: cmspromotionCode
  } = basic

  return { cid, isWx, url, activityType, params, activityCode, guestUrl, cmspromotionCode }
}

/**
 * 解析请求 URL、请求方式等
 */
function resolveRequestConfig(_v, { url, activityType, guestUrl }) {
  let isFormData = activityType === 5
  let activityTypeNew = activityType
  let requestUrl = url

  const { shareCode } = BsUtil.getQuery()
  const isGuestPage = location.pathname.includes('guest')

  if (!_v.liebianPageCommon && (isFormData || shareCode) && isGuestPage) {
    if (_v.productName === 'web-10d39cp' || _v.productName === 'web-10d5b2r') return
    requestUrl = guestUrl || '/activity-platform/interact/guest/help'
    isFormData = true
    activityTypeNew = 5
  }

  return { requestUrl, isFormData, activityTypeNew }
}

function deepMerge(target) {
  const len = target.length
  var first = target[0]
  if (len === 1) return first
  const activityTemplateList = first.map?.data?.activityTemplateList
  if (!activityTemplateList) return first
  for (let i = 1; i < len; i++) {
    const List = target[i].map?.data?.activityTemplateList
    if (List) {
        activityTemplateList.push(...List)
    }
  }
  return first
}

/**
 * 构建请求数据
 */
function buildRequestData({ baseData, cid, isFormData, isWx, acCode, acType, condition, paramsList }) {
  const { sceneCode, activityCode: url_activityCode, promotionCode = '', conditionList, shareCode, extraCode = '' } = BsUtil.getQuery()
  condition = condition || conditionList
  const params = []
  ;([promotionCode, ...extraCode.split('_')]).forEach(code => {
    code && params.push({
        ...(baseData.params || {}),
        userCid: cid,
        terminalType: isFormData ? 4 : (isWx ? 'MINI_PG' : 'APP'),
        ...(acCode && { activityCode: acCode }),
        ...(condition && { conditionList: condition }),
        ...(acType && { activityTemplateType: acType }),
        ...(isFormData && shareCode && { shareCode, resultType: 0, needUserTask: 1 }),
        ...(sceneCode && { sceneCode }),
        ...(baseData.activityType !== 'dacu' && url_activityCode && { activityCode: url_activityCode }),
        ...(code && { promotionCode: code }),
        ...paramsList
    })
  })
  return params
}

/**
 * 发起请求并做埋点
 */
async function fetchActivityData({ requestUrl, requestData, isFormData, fn, _v }) {
  const method = isFormData ? 'POST' : 'GET'
  const requestPayload = isFormData ? BsUtil.stringify(requestData) : requestData
  const response = await BsAjax({
    method,
    url: `${BsGetcapis}/web${requestUrl || '/activity-platform/promotion/act/predict'}`,
    [isFormData ? 'data' : 'params']: requestPayload
  })

  fn && fn(response)

  try {
    _v.$track.addStat('interface_loadedss', {
      code1: response?.data?.map?.code,
      message1: response?.data?.map?.message,
      dataList: JSON.stringify(response?.data?.map || {})
    })
  } catch (error) {
    console.log(error)
  }
  return response.data
}

/**
 * 更新 Vue 数据
 */
function updateVueState(_v, activityList) {
  _v.$root.$data.activeData = { ..._v.$root.$data.activeData, ...activityList }
}

/**
 * 统一错误处理
 */
function handleError(error, _v) {
  console.error('Failed to fetch active data:', error)
  _v.$didafe?.toast('网络异常，请稍后重试')
}
/**
 * 处理响应数据，构造活动列表
 */
function processResponseData(response, activityType, activityCode) {
    const activityList = {
        activeKey: []
    }

    if (activityType !== 'dacu') {
        const data = response
        activityList.promotionStatus = data?.data?.errorCode || data?.code
        activityList.promotionMsg = data?.data?.errorMsg || data?.message
        activityList[activityType] = [{
            activityCode,
            activityInfo: data?.data,
            code: data?.data?.errorCode || data?.code,
            msg: data?.data?.errorMsg || data?.message
        }]
    } else {
        const { map } = response
        activityList.hitUserGroup = map?.data?.hitUserGroup
        activityList.promotionStatus = map?.code ?? response.code
        activityList.promotionMsg = map?.message ?? response.message
        activityList.currentTime = map?.data?.currentTime

        if (map?.data) {
            const leibianCode = {}
            const shengjiCode = {}
            map.data.activityTemplateList?.forEach(item => {
                item.activityList?.forEach(activity => {
                    if (activity?.activityInfo && typeof activity.activityInfo === 'string') {
                        try {
                            activity.activityInfo = JSON.parse(activity.activityInfo) || {}
                        } catch {
                            activity.activityInfo = {}
                        }
                    }

                    const typeKey = item.activityTemplateType
                    const locationKey = activity?.locationCode ? `${typeKey}_${activity.locationCode}` : `${typeKey}`
                    // 获取基于位置的活动编码
                    const locationActivityCode = activity?.locationCode ? `activityCode_${activity.locationCode}` : `activityCode`

                    if (typeKey === 5) {
                        // 裂变活动
                        const activityCode = activity.activityCode
                        if (activity?.activityInfo?.activityInfo?.material?.frontStyleTemplate === 13) {
                            leibianCode[locationActivityCode] = activityCode
                        } else {
                            activityList[locationActivityCode] = activityCode
                        }
                    }

                    if (typeKey === 10) {
                        // 升级活动
                        shengjiCode[locationActivityCode] = activity.activityCode
                    }

                    Object.keys(leibianCode).forEach(item => {
                        activityList[item] = shengjiCode[item] ? [leibianCode[item], shengjiCode[item]] : leibianCode[item]
                    })

                    activityList.activeKey.push(locationKey)

                    if (!activityList[locationKey]) activityList[locationKey] = []
                    activityList[locationKey].push(activity)
                })
            })
        }
    }
    return activityList
}
